module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-copy-cals text-dark"
  }, [_c('div', {
    staticClass: "d-acc",
    class: {
      'd-acc--open': _vm.isAccOpen
    }
  }, [_c('div', {
    staticClass: "d-acc__header",
    on: {
      "click": _vm.toggleIsAccOpen
    }
  }, [_c('div', {
    staticClass: "d-acc__header__left"
  }, [_c('div', {
    staticClass: "d-toggle-arrow",
    class: {
      'd-toggle-arrow--open': _vm.isAccOpen
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.title) + " (" + _vm._s(_vm.calendarsExclArchived.length) + ")")])])]), _vm._v(" "), (_vm.isAccOpen) ? _c('ul', {
    staticClass: "d-copy-cals__list"
  }, [_c('li', {
    staticClass: "d-copy-cals__list__header"
  }, [_c('p', {
    staticClass: "d-acc__header__select-all select-all-item",
    on: {
      "click": _vm.toggleAllKlasses
    }
  }, [(_vm.selectedCalIds.length < 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))])]), _vm._v(" "), _c('div', {
    staticClass: "d-copy-cals__list__header__right"
  }, [_c('p', [_vm._v(_vm._s(_vm.selectedCalIds.length) + " " + _vm._s(_vm.$t('vue2.calendars.selected_of')) + " " + _vm._s(_vm.calendarsExclArchived.length))]), _vm._v(" "), (_vm.selectedCalIds.length < 1) ? _c('button', {
    staticClass: "bttn--disabled hint--bottom-left",
    attrs: {
      "aria-label": this.$t('vue2.calendars.select_calendars_to_copy')
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.calendars.delete')) + " " + _vm._s(_vm.fromDateAndToDate) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.selectedCalIds.length > 0 && !_vm.isDeleting) ? _c('button', {
    staticClass: "bttn bttn-danger hint--bottom-left",
    attrs: {
      "aria-label": "Both dates are included"
    },
    on: {
      "click": _vm.deleteDays
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.calendars.delete')) + " " + _vm._s(_vm.fromDateAndToDate) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.selectedCalIds.length > 0 && _vm.isDeleting) ? _c('button', {
    staticClass: "bttn--disabled bttn-danger bttn--with-spinner"
  }, [_c('Loader', {
    staticStyle: {
      "margin": "0 7px 0 0"
    },
    attrs: {
      "is-extra-small": true
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('vue2.calendars.delete')) + " " + _vm._s(_vm.fromDateAndToDate) + "\n          ")], 1) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.calendarsExclArchived), function(calendar) {
    return _c('li', {
      key: calendar.id,
      staticClass: "d-copy-cals__cal",
      class: {
        'd-copy-cals__cal--selected': _vm.getIsInSelectedCalIds(calendar.id)
      },
      on: {
        "click": function($event) {
          return _vm.toogleCal(calendar.id)
        }
      }
    }, [_vm._m(0, true), _vm._v("\n        " + _vm._s(calendar.name) + "\n      ")])
  })], 2) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-copy-cals__cal__selector"
  }, [_c('div', {
    staticClass: "checkbox"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a0b98898!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendars/CalendarsDeleteEventsInDays.vue
// module id = 2073
// module chunks = 1